//#region Util Imports

import * as moment from 'moment'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { i18n } from '../i18n/common.i18n'
import { EventsNames } from '../../../helpers/events-names'
import { LoggerService } from '../common.module'
import { IUserSession, TemplateHelper, ConfigHelper } from '../../../helpers'
import { IMRBaseControlDirectiveController } from '../base'

export interface CustomDatePeriod {
    id: any
    title: string
}

export interface DatePickerBridge {
    fromDate: Date
    toDate: Date
    customPeriods?: CustomDatePeriod[]
    callback(customPeriod: CustomDatePeriod): void
    isSmallScreen?: boolean
}

interface DatePickerScope extends ng.IScope {
    source: DatePickerBridge
    fromDateBoxOptions: DevExpress.ui.dxDateBoxOptions
    toDateBoxOptions: DevExpress.ui.dxDateBoxOptions
    fromDateBox: DevExpress.ui.dxDateBox
    toDateBox: DevExpress.ui.dxDateBox
    periodButtonOptions: DevExpress.ui.dxButtonOptions
    smScreenPeriodButtonOptions: DevExpress.ui.dxButtonOptions
    prevButtonOptions: DevExpress.ui.dxButtonOptions
    nextButtonOptions: DevExpress.ui.dxButtonOptions

    isCustom: boolean
    hidePickers: boolean

    periodPopoverVisible: boolean
    periodPopoverOptions: DevExpress.ui.dxPopoverOptions
    periodPopover: DevExpress.ui.dxPopover
    periodListOptions: DevExpress.ui.dxListOptions
    selectedPeriod: string
    periods: {
        day: string, week: string, month: string, year: string, custom: string
    }
}

export class DatePickerDirectiveController extends IMRBaseControlDirectiveController {
    constructor($scope: DatePickerScope, $q: ng.IQService, $timeout: ng.ITimeoutService, logger: LoggerService, private userSession: IUserSession) {
        super()

        var date = new Date()
        date.setDate(date.getDate() - 6)

        var fromReseted = false

        var fromDate = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.FromDate, date)
        var fromDateMoment = moment(new Date(fromDate.toString()), window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))
        if (!fromDateMoment.isValid()) {
            fromDateMoment = moment(fromDate)
            if (!fromDateMoment.isValid()) {
                fromDateMoment = moment().subtract(7, 'd')
                fromReseted = true
            }
        }
        $scope.source.fromDate = fromDateMoment.add(-fromDateMoment.toDate().getTimezoneOffset(), 'minutes').toDate()
        $scope.source.fromDate.setHours(0, 0, 0, 0)

        $scope.$on(EventsNames.CHANGE_FROM_TO_DATE, (event, ...args) => {
            if (args) {
                var fromDate = args[0]
                var toDate = args[1]

                $scope.fromDateBox.option('value', fromDate)
                $scope.toDateBox.option('value', toDate)
            }
        })

        var periods = {
            day: i18n("Common", "Day"),
            week: i18n("Common", "Week"),
            month: i18n("Common", "Month"),
            year: i18n("Common", "Year"),
            custom: i18n("Common", "Custom")
        }

        var periodItems = [periods.day, periods.week, periods.month, periods.year, periods.custom]
        $scope.periods = periods

        var createDateBoxReadOnly = (component: DevExpress.ui.dxDateBox) => {
            var dateBoxElement = angular.element(component.element())
            $timeout(() => {
                var input = dateBoxElement.find('.dx-texteditor-input').attr('readonly', 'readonly').css('cursor', 'pointer')
                input.off('click')
                input.on('click', () => {
                    component.open()
                })
            })
        }

        $scope.fromDateBoxOptions = <any>{
            acceptCustomValue: true,
            type: 'date',
            max: null,
            displayFormat: window['simax'].getDateFormat('DATE_FORMAT_DX'),
            onInitialized: e => {
                $scope.fromDateBox = e.component
                //$timeout(() => {
                //    $scope.fromDateBox.repaint()
                //})
            },
            onContentReady: e => {
                createDateBoxReadOnly(e.component)
            },
            dateOutOfRangeMessage: i18n('Common', 'ValueIsOutOfRange'),
            onValueChanged: object => {
                var fromDate = moment(object.value).toDate()
                fromDate.setHours(0, 0, 0, 0)
                $scope.source.fromDate = fromDate
                $scope.toDateBox.option("min", fromDate)
                if (fromDate > $scope.source.toDate) {
                    var toDate = moment(fromDate).toDate()
                    $scope.source.toDate = toDate = moment(fromDate).toDate()
                }
                if ($scope.selectedPeriod != periods.custom) {
                    var toDate = moment(fromDate).toDate()
                    switch ($scope.selectedPeriod) {
                        case periods.week:
                            toDate.setDate(toDate.getDate() + 6)
                            break;
                        case periods.month:
                            toDate.setMonth(toDate.getMonth() + 1)
                            break;
                        case periods.year:
                            toDate.setFullYear(toDate.getFullYear() + 1)
                            break;
                    }
                }
                if (toDate) {
                    toDate.setHours(23, 59, 59, 999)
                    $scope.source.toDate = toDate
                    $scope.toDateBox.option("value", toDate)
                }
                $scope.source.callback(getPeriod($scope.selectedPeriod))
                OperatorLayoutSettings.setSetting(OperatorLayoutSettings.FromDate, $scope.source.fromDate)
            },
            value: $scope.source.fromDate
        }

        var toDate = OperatorLayoutSettings.getSetting(OperatorLayoutSettings.ToDate, new Date())
        if (fromReseted) {
            $scope.source.toDate = moment().toDate()
        } else {
            var toDateMoment = moment(new Date(toDate.toString()), window['simax'].getDateFormat('DATE_TIME_FORMAT_MOMENTJS'))
            if (!toDateMoment.isValid()) {
                toDateMoment = moment(toDate)
                if (!toDateMoment.isValid()) {
                    toDateMoment = moment()
                    $scope.source.fromDate = moment().subtract(7, 'd').toDate()
                }
            }
            $scope.source.toDate = toDateMoment.toDate()
        }

        $scope.source.toDate.setHours(23, 59, 59, 999)

        if ($scope.source.fromDate > $scope.source.toDate) {
            $scope.source.toDate.setDate($scope.source.fromDate.getDate() + 6)
            if ($scope.source.toDate > new Date()) {
                $scope.source.toDate.setTime(new Date().getTime())
                $scope.source.fromDate.setDate($scope.source.toDate.getDate() - 6)
            }
            $scope.source.toDate.setHours(23, 59, 59, 999)
        }

        $scope.toDateBoxOptions = <any>{
            acceptCustomValue: true,
            type: 'date',
            max: null,
            displayFormat: window['simax'].getDateFormat('DATE_FORMAT_DX'),
            onInitialized: e => {
                $scope.toDateBox = e.component
                e.component.option("min", $scope.source.fromDate)
                //$timeout(() => {
                //    $scope.toDateBox.repaint()
                //})
            },
            onContentReady: e => {
                createDateBoxReadOnly(e.component)
            },
            dateOutOfRangeMessage: i18n('Common', 'ValueIsOutOfRange'),
            onValueChanged: object => {
                var toDate = moment(object.value).toDate()
                toDate.setHours(23, 59, 59, 999)
                $scope.source.toDate = toDate
                if ($scope.selectedPeriod != periods.custom) {
                    var fromDate = moment(toDate).toDate()
                    switch ($scope.selectedPeriod) {
                        case periods.week:
                            fromDate.setDate(fromDate.getDate() - 6)
                            break;
                        case periods.month:
                            fromDate.setMonth(fromDate.getMonth() - 1)
                            break;
                        case periods.year:
                            fromDate.setFullYear(fromDate.getFullYear() - 1)
                            break;
                    }
                    fromDate.setHours(0, 0, 0, 0)
                    $scope.source.fromDate = fromDate
                    $scope.fromDateBox.option("value", fromDate)
                }
                $scope.source.callback(getPeriod($scope.selectedPeriod))
                OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ToDate, $scope.source.toDate)
            },
            value: $scope.source.toDate
        }

        $scope.prevButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.PREV, this.userSession),
            hint: i18n("Grid", "PreviousTimePeriod"),
            onClick: e => {
                var fromDate = $scope.source.fromDate
                var toDate = $scope.source.toDate
                slidePeriod(fromDate, toDate, -1)
            }
        }

        $scope.nextButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.NEXT, this.userSession),
            hint: i18n("Grid", "NextTimePeriod"),
            onClick: e => {
                var fromDate = $scope.source.fromDate
                var toDate = $scope.source.toDate
                slidePeriod(fromDate, toDate, 1)
            }
        }

        var togglePopover = () => {
            $scope.periodPopoverVisible = !$scope.periodPopoverVisible
        }

        $scope.periodButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.DATE_RANGE, this.userSession),
            hint: i18n("Grid", "Period"),
            onClick: () => {
                $scope.periodPopover.option("target", '#period-button-' + $scope.$id)
                $scope.periodPopover.option("position", "bottom")
                togglePopover()
            }
        }

        $scope.smScreenPeriodButtonOptions = {
            text: i18n("Common", "ChooseRange"),
            onClick: () => {
                $scope.periodPopover.option("target", '#sm-screen-period-button-' + $scope.$id)
                $scope.periodPopover.option("position", "left")
                togglePopover()
            }
        }

        $scope.periodPopoverVisible = false


        $scope.periodPopoverOptions = {
            target: '#period-button-' + $scope.$id,
            width: 100,
            bindingOptions: {
                visible: 'periodPopoverVisible'
            },
            onInitialized: e => {
                $scope.periodPopover = e.component
            },
            onShowing: e => {
                $timeout(() => {
                    const $element: JQuery = e.component.content()

                    $element
                        .css({
                            'padding': 0,
                            'text-align': 'center',
                            'border-radius': 'inherit'
                        })
                        .closest('.dx-popup-wrapper')
                        .css('z-index', 3000)
                })
            }
        }

        var getPeriod = (selectedPeriodName) => {
            for (let key in periods) {
                if (periods[key] == selectedPeriodName) return {
                    id: key, title: selectedPeriodName
                }
            }
            return {
                id: "day",
                title: periods.day
            }
        }

        if ($scope.source.customPeriods)
            $scope.source.customPeriods.forEach((option, index) => {
                periods[option.id] = option.title
                periodItems.splice(index, 0, option.title)
            })

        $scope.selectedPeriod = periods.custom
        var selectedPeriodIndex = periodItems.indexOf($scope.selectedPeriod)

        $scope.periodListOptions = {
            items: periodItems.map(o => { return { text: o } }),
            onItemClick: e => {
                $scope.periodPopoverVisible = false
                e.component.option("items")[selectedPeriodIndex].disabled = false
                e.itemData.disabled = true
                $scope.selectedPeriod = e.itemData.text
                selectedPeriodIndex = e.itemIndex
                $scope.$emit(EventsNames.REFRESH_ACTION_FILTERS_POPOVER_POSITION);

                if ($scope.selectedPeriod != periods.custom) {
                    if (selectedPeriodIndex < $scope.source.customPeriods.length) {
                        $scope.hidePickers = true
                        $scope.source.callback($scope.source.customPeriods[selectedPeriodIndex])
                        return
                    } else {
                        $scope.source.fromDate = new Date()//moment($scope.source.fromDate).toDate()
                        $scope.source.fromDate.setHours(0, 0, 0, 0)
                        var fromDate = $scope.source.fromDate
                        var toDate = new Date()
                        toDate.setHours(23, 59, 59, 999)
                        switch ($scope.selectedPeriod) {
                            case periods.day:
                                fromDate.setDate(toDate.getDate())
                                break;
                            case periods.week:
                                fromDate.setDate(toDate.getDate() - 6)
                                break;
                            case periods.month:
                                fromDate.setMonth(toDate.getMonth() - 1)
                                break;
                            case periods.year:
                                fromDate.setFullYear(toDate.getFullYear() - 1)
                                break;
                        }
                        $scope.fromDateBox.option("value", fromDate)
                        $scope.toDateBox.option("value", toDate)
                    }
                }
                $scope.hidePickers = false
                $scope.source.callback(getPeriod($scope.selectedPeriod))
            },
            onItemRendered: e => {
                if (e.itemData.text == $scope.selectedPeriod)
                    e.itemData.disabled = true
            }
        }

        var slidePeriod = (fromDate, toDate, multiply: number) => {
            switch ($scope.selectedPeriod) {
                case periods.day:
                    fromDate.setDate(fromDate.getDate() + 1 * multiply)
                    toDate = $scope.source.toDate = moment(fromDate).toDate()
                    toDate.setDate(fromDate.getDate())
                    break;
                case periods.week:
                    fromDate.setDate(fromDate.getDate() + 7 * multiply)
                    toDate = $scope.source.toDate = moment(fromDate).toDate()
                    toDate.setDate(fromDate.getDate() + 6)
                    break;
                case periods.month:
                    fromDate.setMonth(fromDate.getMonth() + 1 * multiply)
                    toDate = $scope.source.toDate = moment(fromDate).toDate()
                    toDate.setMonth(fromDate.getMonth() + 1)
                    break;
                case periods.year:
                    fromDate.setFullYear(fromDate.getFullYear() + 1 * multiply)
                    toDate = $scope.source.toDate = moment(fromDate).toDate()
                    toDate.setFullYear(fromDate.getFullYear() + 1)
                    break;
                case periods.custom:
                    var diff = (toDate.getTime() - fromDate.getTime()) + 1
                    if (diff) {
                        fromDate.setTime(fromDate.getTime() + diff * multiply)
                        toDate.setTime(toDate.getTime() + diff * multiply)
                    }
            }

            toDate = moment(toDate).toDate()
            toDate.setHours(23, 59, 59, 999)

            $scope.fromDateBox.option("value", fromDate)
            $scope.toDateBox.option("min", new Date(fromDate.valueOf()))
            $scope.toDateBox.option("value", toDate)

            // fix for datePicker onChange
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.FromDate, fromDate)
            OperatorLayoutSettings.setSetting(OperatorLayoutSettings.ToDate, toDate)

            $timeout(() => {
                $scope.fromDateBox.repaint()
                $scope.toDateBox.repaint()
            }, 0)
            $scope.source.callback(getPeriod($scope.selectedPeriod))
        }
    }
}